import workspaceQuery from '../../../graphql/queries/sales/QuotationDocumentWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/QuotationDocumentListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/QuotationDocumentQuery.graphql';
import fragment from '../../../graphql/fragments/sales/QuotationDocumentFragment.graphql';

import generateMutation from '../../../graphql/mutations/sales/QuotationDocumentGenerateMutation.graphql';
import generateRangeMutation from '../../../graphql/mutations/sales/QuotationDocumentGenerateRangeMutation.graphql';
import reprintMutation from '../../../graphql/mutations/sales/QuotationDocumentReprintMutation.graphql';

import * as printFunctions from '../../../actions/sales/QuotationDocumentAction';
import { salesDocument } from '../../../utils/mailMergeFields';
import { EntityType } from '../../../@types/entityTypes';
import { ReportType } from '../../schema/p4types';

const QuotationDocument: EntityType = {
  type: 'QuotationDocument',
  title: 'Quotation Report',
  formUrl: '/Sales/QuotationDocuments/Form/',
  formTitle: 'Print Quotation Documents',
  workspaceUrl: '/Sales/QuotationDocuments/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  generate: generateMutation,
  generateRange: generateRangeMutation,
  reprint: reprintMutation,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentSuffix',
  },
  fragment,
  printFunctions: printFunctions,
  screenReference: 'SALES_DOCUMENTS_PRINT_QUOTES',
  configuration: {
    title: 'Quotations',
    field: 'quotationDocumentDefault',
    reportType: ReportType.SalesQuote,
    customerField: 'customerQuotationDocumentDefault',
    receiveFlag: 'receiveQuotationDocuments',
  },
  operations: 0,
  mergeFields: salesDocument,
};

export default QuotationDocument;
